import { get, post } from ".";
import { locaTable } from "../database/tables/LOCA";

export const fetchDrillholesIDsFromServer = async (
  project_id,
  callback,
  errorCallback
) => {
  get(
    `project/${project_id}/getDrillholes`,
    (data) => {
      callback(data);
    },
    errorCallback
  );
};

export const fetchDrillholeFromServer = async (
  project_id,
  drillhole_id,
  callback,
  errorCallback
) => {
  return new Promise((resolve, reject) => {
    get(`project/${project_id}/getDrillhole?id=${drillhole_id}`, (data) => {
      const updatedDrillhole = data.drillhole;
      if (callback) {
        callback(updatedDrillhole);
      }
      resolve(updatedDrillhole);
    });
  });
};

export const syncDrillhole = async (projectId, drillhole, id, callback) => {
  return await post(
    `project/${projectId}/syncDrillhole?id=${id}`,
    drillhole,
    (response) => {
      get(`project/${projectId}/getDrillhole?id=${id}`, (data) => {
        const updatedDrillhole = data.drillhole;
        if (callback) {
          callback(updatedDrillhole);
        }
      });
    }
  );
};

const checkUTCTime = (Modified) => {
  try {
    var ModifiedISOTime;
    if (typeof Modified === "string" && Modified.endsWith("Z")) {
      const ModifiedDate = new Date(Modified);
      ModifiedISOTime = ModifiedDate.toISOString();
    } else if (
      typeof Modified === "string" &&
      !Modified.endsWith("Z") &&
      Modified.includes("T")
    ) {
      const ModifiedDate = Modified + "Z";
      ModifiedISOTime = ModifiedDate;
    } else if (typeof Modified !== "undefined") {
      const eightHoursInMs = 8 * 60 * 60 * 1000;
      const ModifiedDate = new Date(Modified);
      const taiwanTime = new Date(ModifiedDate.getTime() + eightHoursInMs);
      ModifiedISOTime = taiwanTime.toISOString();
    }
  } catch (error) {}
  return ModifiedISOTime;
};

const syncAllData = async (
  project_id,
  localDrillholes,
  commonIDs,
  onlyServerIDs
) => {
  try {
    // 分別處理三種情況
    // local有 server有
    const commonTasks = commonIDs.map(async (id) => {
      // 5.都有：透過drillID取得local的drillhole
      const localDrillhole = localDrillholes.find((d) => d.id === id);
      // 6.都有：透過drillID取得server的drillhole
      const cloudDrillhole = await fetchDrillholeFromServer(
        project_id,
        id,
        (drillHoleData) => {}
      );
      console.log("---cloudDrillhole---", cloudDrillhole);
      console.log("---cloudDrillhole---", typeof cloudDrillhole);
      return cloudDrillhole;
      // // 7.都有：逐一比對每一筆drillhole的每一個table的modified_at
      // await syncDrillhole(project_id, localDrillhole, cloudDrillhole);
      // return { type: "common", id };
    });

    // // local沒有 server有
    // const serverTasks = onlyServerIDs.map(async (id) => {
    //   const drillHoleData = await fetchDrillholeFromServer(project_id, id);
    //   // 10.server有：將最新的存到local
    //   await locaTable.addDrillhole(drillHoleData, project_id, false);
    //   return { type: "server", id };
    // });

    // // 並行執行所有任務
    // const results = await Promise.all([...commonTasks, ...serverTasks]);

    // // 處理結果
    // const completed = {
    //   common: results.filter((r) => r.type === "common").length,
    //   server: results.filter((r) => r.type === "server").length,
    //   local: results.filter((r) => r.type === "local").length,
    // };

    // console.log("同步完成統計:", completed);
    // const latestLocalDrillholes = await locaTable.getAllDrillholes(project_id);
    // return latestLocalDrillholes;
  } catch (error) {
    console.error("同步過程發生錯誤:", error);
  }
};

export const getProjectDrillholes = async (
  project_id,
  callback,
  errorCallback
) => {
  try {
    // 2.取得local所有的drillID - DONE
    // 3.取得server所有的drillID - DONE
    // 4.逐一判斷server & local都有的drillID - DONE
    // 4.1 取得local所有的localDrillhole - DONE
    // 4.2 取得server所有的serverDrillhole - DONE
    // 5.都有：透過drillID取得local的drillhole - DONE
    // 6.都有：透過drillID取得server的drillhole - DONE
    // 7.都有：逐一比對每一筆drillhole的每一個table的modified_at - DONE
    // 8.都有：local比較新：post最新到server - DONE
    // 9.都有：server比較新：將最新的存到local
    // 10.server有：將最新的存到local

    // 2.取得local所有的drillID
    const localDrillholes = await locaTable.getAllDrillholes(project_id);
    const localAllIDs = localDrillholes.map((drill) => drill.id);

    // 3.取得server所有的drillID
    const getServerIDs = () =>
      new Promise((resolve) => {
        fetchDrillholesIDsFromServer(project_id, (cloudDrillholeIds) => {
          resolve(cloudDrillholeIds);
        });
      });
    const serverAllIDs = await getServerIDs();

    // 4.逐一判斷server & local都有的drillID
    const commonIDs = localAllIDs.filter((id) => serverAllIDs.includes(id));

    // 10.server有：將最新的存到local
    const onlyServerIDs = serverAllIDs.filter(
      (id) => !localAllIDs.includes(id)
    );

    const result = await syncAllData(
      project_id,
      localDrillholes,
      commonIDs,
      onlyServerIDs
    );
    console.log("---Result---", typeof result);
    console.log("---Result---", result);
    return result;
    // return await locaTable.getAllDrillholes(project_id);
  } catch (error) {
    if (errorCallback) {
      errorCallback(error);
    } else {
      console.error("Error:", error);
    }
  }
};
